const ProviderFetch = (url: string) => {
    return fetch(url)
        .then((response) => {
            if (response.status !== 200) {
                return [];
            }

            return response.json();
        })
        .then((response) => {
            return response[0].options || [];
        })
        .catch((err) => {
            console.error('Error:', err);
            return [];
        });
};

export default ProviderFetch;
